import { useState } from 'react';
import { Button, Popover, PopoverContent, PopoverTrigger } from '@predoc/cow';
import { ChevronDown, FileText } from 'lucide-react';
import { isEfaxCompleted, type EfaxQueueItem } from '../../types';

interface DocumentPickerCellProps {
  item: EfaxQueueItem;
  onViewDocument: (documentId: string) => void;
}

const getDocumentCategoryLabel = (category?: string) => {
  const trimmed = category?.trim();
  return trimmed ? trimmed : '—';
};

export const DocumentPickerCell = ({
  item,
  onViewDocument,
}: DocumentPickerCellProps) => {
  const [open, setOpen] = useState(false);

  const outputDocs = item.output.documents;

  if (!isEfaxCompleted(item.status) || outputDocs.length === 0) return null;
  const totalDocs = outputDocs.length;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          className="h-auto gap-1 px-2 py-1 text-sm font-normal"
        >
          <FileText className="size-3.5 shrink-0" />
          {totalDocs}
          <ChevronDown className="size-3 shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-96 max-w-96 overflow-x-hidden p-0"
        align="start"
      >
        <div className="min-w-0 space-y-3 p-3">
          {outputDocs.map((doc) => {
            const label = doc.name?.trim() ? doc.name : doc.documentType;

            return (
              <button
                key={doc.documentId}
                type="button"
                onClick={() => {
                  setOpen(false);
                  onViewDocument(doc.documentId);
                }}
                className="hover:bg-accent flex w-full min-w-0 cursor-pointer items-start gap-2 rounded-md px-2 py-2 text-left text-sm transition-colors"
              >
                <FileText className="text-muted-foreground mt-0.5 size-3.5 shrink-0" />
                <span className="min-w-0 flex-1">
                  <span className="block leading-snug font-medium break-all">
                    {label}
                  </span>
                  <span className="text-muted-foreground mt-0.5 block text-xs leading-snug break-all">
                    {getDocumentCategoryLabel(doc.category)}
                  </span>
                </span>
              </button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
};
